import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import PrivateRoute from './components/PrivateRoute'
import Login from './pages/Login'
import Appointments from './pages/Appointments'
import News from './pages/News'
import StudyDetail from './pages/News/StudyDetail'

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/" exact component={Login} />
      <PrivateRoute exact path="/inicio" component={Appointments} />
      <PrivateRoute exact path="/inicio/novedades" component={News} />
      <PrivateRoute exact path="/inicio/novedades/:studyId" component={StudyDetail} />
    </Switch>
  </BrowserRouter>
)

export default Routes
